import { HashedPermission } from "../config/permissions";

export type GrantablePermission = {
  name: string;
};

export type GrantableRole = {
  name: string;
  permissions: readonly GrantablePermission[];
};

export type PermissionGrantor = {
  isRoot: boolean;
  canGrantPermission: (permission: string) => boolean;
  canGrantRole: (role: GrantableRole) => boolean;
};

/**
 * A user may only pass on permissions they hold themselves.
 * Root grants anything.
 */
export const createPermissionGrantor = (
  holderPermissions: readonly string[],
): PermissionGrantor => {
  const held = new Set<string>(holderPermissions);
  const isRoot = held.has(HashedPermission.SYSTEM_ROOT);

  return {
    isRoot,
    canGrantPermission: (permission) => isRoot || held.has(permission),
    canGrantRole: (role) =>
      isRoot || role.permissions.every(({ name }) => held.has(name)),
  };
};
